const links = {
  regulations: 'https://www.wiosna.org.pl/regulamin-serwisu/',
  privacyPolicy: 'https://www.wiosna.org.pl/polityka-prywatnosci/',
  academyInnumbers: 'https://akademiaprzyszlosci.org.pl/akademia-w-liczbach/',
  academyFaq: 'https://akademiaprzyszlosci.org.pl/faq/',
  homeAp: 'https://akademiaprzyszlosci.org.pl/',
  otherFormOfHelp: 'https://akademiaprzyszlosci.org.pl/pomagaj-akademii/',
  blogAp: 'https://akademiaprzyszlosci.org.pl/blog/',
  websiteSpring: 'https://www.wiosna.org.pl/',
  socialLinks: {
    facebook: 'https://www.facebook.com/akademia.przyszlosci/',
    instagram: 'https://www.instagram.com/akademiaprzyszlosci/',
    youtube: 'https://www.youtube.com/user/TVakademii/',
    linkedin: 'https://www.linkedin.com/showcase/akademia-przysz%C5%82o%C5%9Bci'
  }
}

export default links
